import { refreshAccessToken } from '@/lib/api/client';
import { useAuthStore } from '@/stores/auth.store';
import { authApi } from './api';

/** Restores the session from the httpOnly refresh cookie on page load. */
export async function bootstrapAuth() {
  const token = await refreshAccessToken();
  if (!token) {
    useAuthStore.getState().signOut();
    return;
  }
  try {
    const user = await authApi.me();
    useAuthStore.getState().setSession(token, user);
  } catch {
    useAuthStore.getState().signOut();
  }
}
